import { _, React, withStyles, StyledProps, CentricTheme } from '@api'

const styles = (theme: CentricTheme) => ({
  drawerContent: {
    marginTop: 0,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 1,
    backgroundColor: theme.colors.white
  }
})

interface MyProps extends StyledProps {
}

@(withStyles as any)(styles)
export class DrawerBody extends React.Component<MyProps> {
  static defaultProps = {
  //  width: 256
  }
  
  render () {
    
    const {children, classes} = this.props
    
    return (
      <div data-type='DrawerBody' className={classes.drawerContent}>
        {children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/DrawerBody.tsx